var address = {};
module['exports'] = address;
address.city_root = require("./city_root");
address.city = require("./city");
address.county = require("./county");
address.default_country = require("./default_country");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/vi/address/index.js
 ** module id = 1158
 ** module chunks = 0
 **/